import { Trash2 } from 'lucide-react'

const TabReferencias = ({ references = [], onChange }) => {
  const MAX_REFERENCIAS = 10

  const set = (i, key, value) => {
    const updated = references.map((ref, idx) => (idx === i ? { ...ref, [key]: value } : ref))
    onChange(updated)
  }

  const add = () => {
    if (references.length >= MAX_REFERENCIAS) return
    onChange([
      ...references,
      {
        reference_doc_type: '',
        reference_folio: '',
        reference_date: '',
        reference_reason: ''
      }
    ])
  }

  const remove = i => onChange(references.filter((_, idx) => idx !== i))

  return (
    <div className='mt-1 p-1'>
      {/* 🧾 Encabezado */}
      <div className='flex justify-between items-center mb-2'>
        <div>
          <h2 className='text-lg font-bold text-slate-800'>Referencias</h2>
          <p className='text-[0.75rem] text-slate-400 mt-0.5 tracking-wide'>
            Máximo {MAX_REFERENCIAS} referencias ({references.length}/{MAX_REFERENCIAS}) — Opcional
          </p>
        </div>
        <button
          className={`flex text-m items-center gap-1.5 px-4 py-1 rounded-full text-white tracking-wide transition-all shadow-md ${references.length >= MAX_REFERENCIAS
            ? 'bg-slate-300 shadow-none cursor-not-allowed text-slate-100'
            : 'bg-accent2 text-white rounded-full'
            }`}
          onClick={add}
          disabled={references.length >= MAX_REFERENCIAS}
        >
          <span className='text-[10px]'>+</span> Agregar Referencia
        </button>
      </div>

      {/* 📋 Tabla de referencias */}
      <div className='max-h-[200px] overflow-y-auto overflow-x-auto rounded-xl border border-slate-100 shadow-sm'>
        <table className='w-full text-sm font-sans whitespace-nowrap min-w-[700px]'>
          <thead className='bg-slate-50/90 border-b border-slate-100 sticky top-0 z-10 backdrop-blur-md'>
            <tr>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-left w-4/12'>
                Tipo
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-left w-2/12'>
                Folio
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-left w-2/12'>
                Fecha
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-left'>
                Observación
              </th>
              <th className='px-4 py-1 text-[0.65rem] uppercase tracking-wider font-bold text-slate-400 text-center w-14'>
              </th>
            </tr>
          </thead>

          <tbody className='divide-y divide-slate-100'>
            {(references || []).length === 0 && (
              <tr>
                <td colSpan='5' className='text-center py-6 text-slate-400 italic text-xs bg-white'>
                  No hay referencias agregadas.
                </td>
              </tr>
            )}

            {(references || []).map((r, i) => (
              <tr key={i} className='bg-white hover:bg-slate-50/50 transition-colors group'>
                <td className='p-2'>
                  <select
                    value={String(r.reference_doc_type || r.dte_type_code || r.reference_type || '')}
                    onChange={e => set(i, 'reference_doc_type', e.target.value)}
                    className='custom-input text-slate-700'
                  >
                    <option value=''>Seleccionar tipo</option>
                    <option value='110'>Factura de Exportación Electrónica (110)</option>
                    <option value='111'>Nota de Débito de Exportación Electrónica (111)</option>
                    <option value='112'>Nota de Crédito de Exportación Electrónica (112)</option>
                    <option value='33'>Factura Electrónica (33)</option>
                    <option value='34'>Factura Exenta Electrónica (34)</option>
                    <option value='39'>Boleta Electrónica (39)</option>
                    <option value='41'>Boleta Exenta Electrónica (41)</option>
                    <option value='52'>Guía Despacho Electrónica (52)</option>
                    <option value='56'>Nota de Débito Electrónica (56)</option>
                    <option value='61'>Nota de Crédito Electrónica (61)</option>
                    <option value='801'>Orden de Compra (801)</option>
                    <option value='HES'>Hoja Entrada Servicio (HES)</option>
                  </select>
                </td>

                <td className='p-2'>
                  <input
                    type='text'
                    value={r.reference_folio || ''}
                    onChange={e => set(i, 'reference_folio', e.target.value)}
                    className='custom-input text-slate-700 font-medium'
                    placeholder='OC-2025-001'
                  />
                </td>

                <td className='p-2'>
                  <input
                    type='date'
                    value={r.reference_date || ''}
                    onChange={e => set(i, 'reference_date', e.target.value)}
                    className='custom-input text-slate-700'
                  />
                </td>

                <td className='p-2'>
                  <input
                    type='text'
                    value={r.reference_reason || ''}
                    onChange={e => set(i, 'reference_reason', e.target.value)}
                    className='custom-input text-slate-500 bg-transparent shadow-none border-transparent hover:bg-slate-50 focus:bg-white focus:border-blue-500/30'
                    placeholder='Razón...'
                  />
                </td>

                <td className='p-2 text-center align-middle'>
                  <button
                    className='px-2 py-1 rounded-md text-red-700 flex items-center'
                    onClick={() => remove(i)}
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ℹ️ Información adicional */}
      <div className='p-4 mt-3 bg-blue-50 font-sans text-blue-800 rounded-md'>
        <span className='font-bold'>Información sobre referencias:</span>
        <ul className='list-disc ml-5 font-sans text-xs mt-2'>
          <li>Las referencias vinculan este documento con otros documentos relacionados.</li>
          <li>Son especialmente útiles para notas de crédito y débito.</li>
          <li>El tipo debe corresponder al documento que se está referenciando.</li>
        </ul>
      </div>

      <style>{`
        .custom-input {
          width: 100%;
          min-height: 38px;
          padding: 0px 10px;
          background-color: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 0.75rem;
          outline: none;
          font-size: 0.75rem;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        }
        .custom-input:focus {
          background-color: #ffffff;
          border-color: rgba(37, 99, 235, 0.5);
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
        }
        /* Custom scrollbar for premium feel */
        .overflow-y-auto::-webkit-scrollbar {
          width: 5px;
        }
        .overflow-y-auto::-webkit-scrollbar-track {
          background: transparent;
        }
        .overflow-y-auto::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
        .overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }
      `}</style>
    </div>
  )
}

export default TabReferencias
